import type { ReactNode } from 'react';
import boldFormatter from './boldFormatter';
import colorFormatter from './colorFormatter';
import newLineFormatter from './newLineFormatter';

const convertMarkdown = (str: string): ReactNode | string =>
  boldFormatter(colorFormatter(newLineFormatter(str)));

export default convertMarkdown;
